import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-input-switch',
  templateUrl: './formly-input-switch.component.html',
  styleUrls: ['./formly-input-switch.component.scss'],
})
export class FormlyInputSwitchComponent extends FieldType {}
